<template>
  <!-- Injuries chart start -->
  <div class="card">
    <v-row justify="center" align="center" class="mx-0">
      <v-col cols="12" md="12" sm="12" class="px-0 px-md-3">
        <v-sheet
          elevation="0"
          class="px-5 py-2 text-center box-shadownon injuries-table"
          rounded
        >
          <!--team depth data table -->
          <div class="mt-0 mt-md-2 tabcontentcustom-bottom">
            <v-data-table
              :headers="InjuriesHeaders"
              :items="injuries"
              :items-per-page="injuries.length"
              :item-key="injuries._id"
              class="elevation-1"
              sort-by="InjuryStartDate"
              sort-desc
              hide-default-footer
              mobile-breakpoint="0"
            >
              <!-- s.no -->
              <template v-slot:item._id="{ index }">
                <p class="body-2">{{ index + 1 }}</p>
              </template>
              <!-- s.no -->

              <!-- player name -->
              <template v-slot:item.Name="{ item }">
                <router-link
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="caption"
                >
                  {{ item.Name }}
                </router-link>
              </template>
              <!-- player name ends -->

              <!--status  -->
              <template v-slot:item.InjuryStatus="{ item }">
                <!-- Blue dot - 'active',
                green dot - 'positive',
                yellow dot -'intermediary'
                red dot - 'negative' -->

                <v-row>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == null"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="positive" pulse />
                      </v-col>
                    </template>
                    <span>Healthy</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == 'Out'"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="negative" pulse />
                      </v-col>
                    </template>
                    <span>Out</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Questionable'"
                      >
                        <status-indicator status="intermediary" pulse />
                      </v-col>
                    </template>
                    <span>Questionable</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Probable'"
                      >
                        <status-indicator status="active" pulse />
                      </v-col>
                    </template>
                    <span>Probable</span>
                  </v-tooltip>
                </v-row>
              </template>
              <!-- status -->

              <!-- InjuryDate -->
              <template v-slot:item.InjuryStartDate="{ item }">
                <p class="caption">{{ item.InjuryStartDate | dateFormat }}</p>
              </template>
              <!-- InjuryDateends -->

              <!-- FPPG -->
              <template v-slot:item.FPPG="{ item }">
                <p class="caption">{{ item.FPPG >> 0 }}</p>
              </template>
              <!-- FPPG ends -->

              <!-- InjuryNotes -->
              <template v-slot:item.InjuryNotes="{ item }">
                <p class="caption">{{ item.InjuryNotes }}</p>
              </template>
              <!-- InjuryNotes ends -->
            </v-data-table>
          </div>
          <!--team depth data table ends -->
        </v-sheet>
      </v-col>
    </v-row>
  </div>
  <!-- Injuries chart start -->
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "Injuries",
  props: {
    injuries: {
      type: Array,
      default: () => [],
    },
  },

  filters: {
    dateFormat: function (value) {
      if (value) {
        return dayjs(value).format("MMM/DD/YYYY");
      }
    },
  },

  data: () => ({
    InjuriesHeaders: [
      {
        text: "Pos. ",
        value: "DraftKingsPosition",
        sortable: false,
      },
      { text: "Player", value: "Name" },
      { text: "Status", value: "InjuryStatus" },
      { text: "Injury Date", value: "InjuryStartDate", sortable: true },
      { text: "Body Part", value: "InjuryBodyPart" },
      { text: "Details", value: "InjuryNotes" },
    ],
  }),
};
</script>

<style scoped></style>
